import React, { useMemo, useState } from 'react';
import classNames from 'classnames';

import { AvailablePhone, CloseSquare, NotAvailablePhone } from '@/icons/index';

import Modal from '../Modal/Modal';
import Tabs from '../Tabs/Tabs';
import TabPanel from '../Tabs/TabPanel';
import Tab from '../Tabs/Tab';
import TabContent from '../Tabs/TabContent';
import TabContentItem from '../Tabs/TabContentItem';
import InputAutoComplete from '../InputAutoComplete/InputAutoComplete';
import Button from '../Button/Button';

import styles from './CompatibleDevicesModalVolte.module.scss';

const CompatibleDevicesModal = ({
  active,
  setActive,
  devices,
  title = '',
  data,
}) => {
  const [activeTab, setActiveTab] = React.useState(0);
  const [available, setAvailable] = useState(null);
  const [value, setValue] = useState('');

  const modelsNames = useMemo(() => {
    let models = [];
    devices?.map((item) =>
      item?.models?.forEach((model) => {
        models = [...models, model];
      }),
    );

    return models;
  }, [devices]);
  const onCheck = () => {
    setAvailable(modelsNames?.map((item) => item?.name)?.includes(value));
  };
  const tabClickHandler = (index) => {
    setActiveTab(index);
    if (activeTab !== index) {
      setValue('');
    }
  };
  const renderTab = (item, index) => {
    return (
      <Tab
        className={styles.tab}
        key={index}
        onClick={() => tabClickHandler(index)}
        itemScope
        itemType='https://schema.org/Text'
      >
        {item?.name}
      </Tab>
    );
  };
  const renderListItem = (item, index) => {
    return (
      <div
        key={index}
        className={styles.item}
        onClick={() => setValue(item?.name)}
        itemScope
        itemType='https://schema.org/ListItem'
      >
        {item?.name}
      </div>
    );
  };
  const renderTabContent = (item, index) => {
    return (
      <TabContentItem
        key={index}
        className={styles.content}
        itemScope
        itemType='https://schema.org/ItemList'
      >
        {item?.models?.map(renderListItem)}
      </TabContentItem>
    );
  };

  return (
    <Modal
      active={active}
      setActive={setActive}
      classNameInner={styles.modal}
      itemScope
      itemType='https://schema.org/Product'
    >
      <strong className={'title'}>{title}</strong>
      <div className={styles.find}>
        {available === null ? (
          <InputAutoComplete
            setValue={setValue}
            value={value}
            filter={modelsNames}
            onSelect={setValue}
            className={styles.input}
            placeholder={data?.devices_modal_input_label}
            models={modelsNames}
            highlight
          />
        ) : (
          <div
            className={classNames([
              styles.available,
              { [styles.notAvailable]: !available },
            ])}
          >
            <span className={classNames(['label', styles.inputLabel])}>
              {data?.devices_modal_input_label}
            </span>
            <div className={styles.content}>
              {available ? (
                <AvailablePhone className={styles.available_device} />
              ) : (
                <NotAvailablePhone />
              )}
              <span className={styles.title}>{value}</span>
            </div>
            <button
              aria-label='Bakcell'
              className={styles.close}
              onClick={() => setAvailable(null)}
              data-testid='modal-close'
            >
              <CloseSquare width={15} height={15} />
            </button>
          </div>
        )}
        <Button disabled={!value} className={styles.button} onClick={onCheck}>
          {data?.devices_modal_button_text}
        </Button>
      </div>
      <Tabs active={activeTab}>
        <TabPanel className={styles.panel}>{devices?.map(renderTab)}</TabPanel>
        <TabContent>{devices?.map(renderTabContent)}</TabContent>
      </Tabs>
    </Modal>
  );
};

export default CompatibleDevicesModal;
